import { useEffect } from "react"
import { useGoogleReviews } from "@/hooks/use-google-reviews"

/**
 * Enriches the static "Store" JSON-LD (in index.html, identified by its
 * @id ending in "#store") with a real aggregateRating sourced from the Google
 * Places API. Because the same numbers are shown on the page, this is genuine,
 * non–self-serving review markup. Renders nothing visually.
 */
export function GoogleReviewSchema() {
  const reviews = useGoogleReviews()

  useEffect(() => {
    if (!reviews?.rating || !reviews.userRatingCount) return

    const scripts = document.querySelectorAll<HTMLScriptElement>(
      'script[type="application/ld+json"]'
    )

    for (const script of scripts) {
      if (!script.textContent) continue
      let data: Record<string, unknown>
      try {
        data = JSON.parse(script.textContent)
      } catch {
        continue
      }

      const id = data["@id"]
      if (typeof id !== "string" || !id.endsWith("#store")) continue

      data.aggregateRating = {
        "@type": "AggregateRating",
        ratingValue: reviews.rating,
        reviewCount: reviews.userRatingCount,
        bestRating: 5,
        worstRating: 1,
      }
      script.textContent = JSON.stringify(data)
      break
    }
  }, [reviews])

  return null
}
